import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import * as PackageInventoryStore from '../../../redux/packageInventory';
import { SearchInput } from '../../generic/Forms';
import useFetchPackages from '../hooks/useFetchPackages';
import type { WithResetSelectedPackage } from '../PackageInventoryContainer';
import PackageSortingDropdown from '../PackageSortingDropdown';
import styles from './PackageSearchAndSort.module.less';

type Props = {
  withResetSelectedPackage: WithResetSelectedPackage;
};

/**
 * PackageInventorySearchAndSort powers the Package Index top bar:
 * searching packages by name and controlling the sorting order.
 */
const PackageInventorySearchAndSort: VoidFunctionComponent<Props> = ({ withResetSelectedPackage }) => {
  const setFilters = useFetchPackages(PackageInventoryStore.actions.setFilters);
  const packageName = useSelector(PackageInventoryStore.selectors.getFiltersPackageName);
  return (
    <div className={styles.filters}>
      <SearchInput
        label="package-search"
        size="small"
        placeholder="Search by package name"
        value={packageName}
        onChange={withResetSelectedPackage((name) => setFilters({ packageName: name }))}
        testId="package-inventory-searchbar"
      />
      <PackageSortingDropdown withResetSelectedPackage={withResetSelectedPackage} />
    </div>
  );
};

export default PackageInventorySearchAndSort;
